
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useThemeColors } from "@/components/analytics/hooks/useThemeColors";
import { CSS_CHART_COLORS } from "@/components/analytics/constants/chartColors";

interface ClientPieChartProps {
  data: { name: string; value: number; }[];
}

export const ClientPieChart = ({ data }: ClientPieChartProps) => {
  const { colors } = useThemeColors();

  const formatTooltipValue = (value: number) => {
    return `$${value.toLocaleString()}`;
  };

  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          paddingAngle={5}
          dataKey="value"
          label={({ name, percent }) => 
            `${name}: ${(percent * 100).toFixed(0)}%`
          }
          labelLine={false}
        >
          {data.map((_, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={colors.primary[index % colors.primary.length]} 
            />
          ))}
        </Pie>
        <Tooltip 
          formatter={formatTooltipValue}
          contentStyle={{ 
            backgroundColor: CSS_CHART_COLORS.background,
            border: `1px solid ${CSS_CHART_COLORS.grid}`,
            borderRadius: '0.5rem',
            color: CSS_CHART_COLORS.text
          }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};
